import { createFileRoute } from '@tanstack/react-router'

// View-only staff read the drill here too; the page hides its write controls.
export const Route = createFileRoute('/_layout/spot-of-the-week/$weekId')({})
